import React from 'react';
import { Text } from '@atlaskit/primitives';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import { useIntl } from '@atlassian/jira-intl';
import type { Priority } from '../../../common/types';
import { messages } from './messages';

type SchemesProps = {
	priority: Priority;
};

const getPrioritySchemesUrl = (priorityId: string) =>
	`/jira/settings/issues/priority-schemes?priorityId=${priorityId}`;

export const Schemes = ({ priority }: SchemesProps) => {
	const { formatMessage } = useIntl();

	if (!priority.schemes.values.length) {
		return <Text>{formatMessage(messages.noSchemes)}</Text>;
	}

	return (
		<Link href={getPrioritySchemesUrl(priority.id)}>
			{priority.schemes.total > 1
				? formatMessage(messages.schemeCount, {
						schemeCount: priority.schemes.total,
					})
				: priority.schemes.values[0].name}
		</Link>
	);
};
